module.exports = __webpack_public_path__ + "static/img/1-2.ce8861e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/1-2.png
// module id = tqam
// module chunks = 0